import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopElecShowroom = dynamic(() => import('../../components/electronics/electronics-showroom/DesktopElectronicsShowroom'), {
  loading: () => <Loading />,

});
const MobileElecShowroom = dynamic(() => import('../../components/electronics/electronics-showroom/MobileElectronicsShowroom'), {
  loading: () => <Loading />,

});
const electronicsShowroom = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Best Electronics Showroom POS Billing Software | QueueBuster</title>
        <link rel="canonical" href="https://queuebuster.co/electronics/electronics-showroom-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/electronics/electronics-showroom-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Optimize your electronics store with efficient POS billing solutions from QueueBuster. Manage sales, inventory, and customer data with ease. Check out the features or take a trial today!" />
        <meta property="og:title" content="Best Electronics Showroom POS Billing Software | QueueBuster" />
        <meta property="og:description" content="Optimize your electronics store with efficient POS billing solutions from QueueBuster. Manage sales, inventory, and customer data with ease. Check out the features or take a trial today!" />
        <meta property="og:url" content="https://queuebuster.co/electronics/electronics-showroom-pos-billing-software" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/electronics-showroom.jpg" />
      </Head>
         <SchemaTags page="electronics-showroom-pos-billing-software" />
      {mobileView ? <MobileElecShowroom /> : <DesktopElecShowroom />}
    </>
  )
}

export default electronicsShowroom